import { Navigate } from "react-router-dom";
import { useUser } from "../context/userContext";
import { normalizeLang } from "../utils/i18n";

export default function OnboardingProtectedRoute({ children }) {
  const { isAuthenticated, loading, isOnboarded, user } = useUser();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isOnboarded) return <Navigate to={`/onboarding/${normalizeLang(user?.lang)}`} replace />;

  return children;
}
